<div class="bloc-title mb-3">live campaigns performance</div>
<div class="chart-holder p-3">
    <div class="d-flex justify-content-between align-items-end mb-3">
        <h4 class="text-gray-500 montserrat-bold">Overall reach</h4>
        <span class="text-gray">Infiniti QX60</span>
    </div>
    <h6 class="text-gray-500 mb-5">January 2020</h6>
    <app-statistics-chart [barChartLabels]="barChartLabels" [data]="data"></app-statistics-chart>
</div>
<div class="bullets d-flex align-items-center justify-content-center">
    <span class="selected"></span>
    <span></span>
    <span></span>
</div>
